export const STORE_MULTIPLE_EXPORTS = 'multipleExportStore';

export const ME_SET_DISABLED_DATA = 'setDisabled';
export const ME_SET_DEFAULT_RADIUS = 'setDefaultRadius';
export const ME_CHANGE_FILE_GROUP = 'changeFileGroup';
export const ME_DOWNLOAD_FILES = 'downloadFiles';
